import {
    ComponentConfig,
    ComponentsConfigs,
    ComponentModuleConfig, ComponentModuleViewConfig
} from '@gongxigames/framework/core/types';

type ConfigsTypes = 'views' | 'modules' | 'classes' | 'singletons' | 'constants' | 'services';

export class ComponentConfigManager {
    constructor(private componentsConfig: ComponentsConfigs[]) {
    }

    public getConfigsByType<C extends ComponentConfig>(type: ConfigsTypes): C[] {
        return this.mergeComponentsConfigs(this.getComponentsConfigsByType(type));
    }

    public getModulesConfigs(): {modules: ComponentModuleConfig[]; views: ComponentModuleViewConfig[];} {
        const filterConfigs = (type: ConfigsTypes) => {
            const componentsConfigs = this.getComponentsConfigsByType(type);

            return this.mergeComponentsConfigs(componentsConfigs);
        };

        return {
            modules: filterConfigs('modules'),
            views: filterConfigs('views') as ComponentModuleViewConfig[]
        };
    }

    private getComponentsConfigsByType<C extends ComponentConfig>(type: ConfigsTypes): C[][] {
        return this.componentsConfig
            .map(config => config[type])
            .filter(Boolean) as C[][];
    }

    private mergeComponentsConfigs<C extends ComponentConfig>(configs: C[][]): C[] {
        const configsMap = new Map<string | symbol, C>();

        configs
            .flat()
            .forEach(config => configsMap.set(config.NAME, config));

        return Array.from(configsMap.values());
    }
}
